import { toast } from "react-toastify";

const options = {
  position: "bottom-left",
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
};

const toaster = {
  success(msg) {
    toast.success(msg, options);
  },
  warning(msg) {
    toast.warning(msg, options);
  },
  info(msg) {
    toast.info(msg, options);
  },
  error(msg) {
    toast.error(msg, options);
  },
};

export default toaster;
